(ns teamoesterreich.admin-mode.lebensretter.lr-feed.lr-feed-list
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.text.get-text :as txt]

            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.lr-feeds :as d-lr-feeds]
            [teamoesterreich.admin-mode.actions :as a]
            [clojure.string :as str]
            [goog.json :as json]

            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]

            [reagent-material-ui.icons.build :refer [build]]

            [reagent-material-ui.icons.add :refer [add]]


            ))



(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (js/Date. (str (subs rest-time 0 4) "-" (subs rest-time 4 6) "-" (subs rest-time 6 11) ":" (subs rest-time 11 13) ":" (subs rest-time 13 19) "-00:00"))))

(defn time-print [rest-time]
  (if (= "" (str rest-time))
    nil
    (let [d (time-conv rest-time)] (str (.toLocaleDateString d) " "  (subs (.toLocaleTimeString d) 0 5)))))


(defn date-print [rest-time]
  (if (= "" (str rest-time))
    nil
    (let [d (time-conv rest-time)] (str (.toLocaleDateString d) ))))




(defn text-block-card [text !opened]
  (let [opened? (= @!opened (get text :lrFeedItem-uuid))
        type (get text :lrFeedItem-type)
        ]
    [mui/card {:style {:backgroundColor (if (get text :lrFeedItem-published) "" "#e6e6e5") :marginBottom "20px"} }
     [mui/card-header
      {:title
       (r/as-element [mui/grid
                      {:container  true
                       :direction  "row"
                       :alignItems "stretch"
                       :justify    "flex-start"
                       }

                      [mui/grid
                       {:item  true
                        :md    3
                        :lg    2
                        :xs    5
                        :style {:height "80px" :textAlign "left" :paddingLeft ""}
                        }
                       (when (:lrFeedItem-thumbnail text)
                         [:img {:src (:lrFeedItem-thumbnail text) :alt "Kein Bild" :height "80"}])
                       ]

                      [mui/grid
                       {:item  true
                        :md    9
                        :lg    10
                        :xs    7
                        :style {:height "80px" :textAlign "left" :paddingLeft "20px"}
                        }
                       [mui/typography {:variant "h5"} (str (date-print (get text :lrFeedItem-date)) " - " (get text :lrFeedItem-title) (when-not (get text :lrFeedItem-published) " - [unveröffentlicht]"))]]]
                     )}]

     [mui/card-actions

      [mui/button {:startIcon (r/as-element [build])
                   :onClick (fn []
                              (reset! !opened (get text :lrFeedItem-uuid))
                              (a/set-page :lebensretter-feed-item))
                   }
       "Bearbeiten"
       ]
      ]

     ]))

(defn get-it []
  (let [!lr-feeds-list (r/cursor vstate/app-state [:lrFeedItem-list])
        !loaded (r/cursor !lr-feeds-list [:loaded])
        !tab (r/cursor !lr-feeds-list [:tab])
        !data (r/cursor !lr-feeds-list [:data])
        !opened  (r/cursor !lr-feeds-list [:opened])
        !show-create-modal (r/cursor !lr-feeds-list [:create])
        reload-fn #(reset! !loaded false)]
    (fn []
      (if-not @!loaded
        (do
          (d-lr-feeds/get-lr-feed-item-list
            (fn [response]
              (swap! !lr-feeds-list assoc :loaded true :data response)))
          [mui/paper
           [:br]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )
        (do

          [mui/grid
           {:container true
            :direction "row"
            :alignItems "stretch"
            :justify "flex-start"
            :spacing 1
            :style {}
            }

           [mui/grid
            {:item  true
             :xs    12
             :style {:margin-top "15px"}
             }
            (let [sel-tab (or @!tab d-lr-feeds/LR_FEED_NEWS)]

              [mui/card
               [mui/card-content {}
                [create-with-name-modal/modal !show-create-modal
                 "Bitte gib den Titel für den neuen Eintrag ein"
                 "Anlegen"
                 (fn [name]
                   (log/debug "Create lr-feeds" sel-tab " with Name: " name)
                   (d-lr-feeds/>new-lr-feed-item name sel-tab (fn [new]
                                                                (log/debug "Created lr-feeds : " new)
                                                                (reload-fn)
                                                                (reset! !opened (:lrFeedItem-uuid new))
                                                                (a/set-page :lebensretter-feed-item)
                                                                ))
                   )
                 ]

                (log/debug "Open LR Feed Tab  " @!tab)
                [mui/tabs {:value (or @!tab 1)
                           :onChange (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                           :indicatorColor "primary"
                           :textColor "primary"
                           :variant "scrollable"
                           }

                 [mui/tab {:value d-lr-feeds/LR_FEED_NEWS :style {:verticalAlign "top"} :label (txt/transl "Lebensretter NEWS") }]
                 [mui/tab {:value d-lr-feeds/LR_FEED_FAQ :style {:verticalAlign "top"} :label (txt/transl "Lebensretter FAQ")}]
                 [mui/tab {:value "99" :style {:verticalAlign "top"} :label "Debug"}]

                 ]]


               (cond



                 (= sel-tab d-lr-feeds/LR_FEED_FAQ)
                 [mui/card-content {}
                  [:h2 (txt/transl "Lebensretter FAQ")]
                  [mui/card-content {:style {:textAlign "left"}}
                   [mui/button {:startIcon (r/as-element [add])
                                :variant "outlined"
                                :color "secondary"
                                :onClick #(reset! !show-create-modal true)}
                    "Eine neue FAQ anlegen"
                    ]]
                  (for [[uuid text] (reverse (sort-by (fn [[uuid n]] (:lrFeedItem-date n)) (filter (fn [[uuid n]] (and (= (get-in n [:lrFeedItem-feed :lrFeed-uuid]) sel-tab) (:lrFeedItem-active n))) @!data)))]
                    ^{:key (str "lrFeedItem-" uuid)}
                    [mui/grid
                     {:container false
                      :item      true
                      :xl        7
                      :xs        12  ;extra-small: 0px
                      }
                     [text-block-card text !opened]
                     ]
                    )
                  ]


                 (= sel-tab "99")
                 [mui/card-content {}
                     [:p "DEBUG Feeds ....."]
                     [:p "LR_FEED_FAQ ....." d-lr-feeds/LR_FEED_FAQ]
                     [:p "LR_FEED_NEWS ....." d-lr-feeds/LR_FEED_NEWS]
                     [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!data)) "," ",\n")]
                     ]

                 :else
                 [mui/card-content {}
                  [:h2  (txt/transl "Lebensretter NEWS")]
                  [mui/card-content {:style {:textAlign "left"}}
                   [mui/button {:startIcon (r/as-element [add])
                                :variant "outlined"
                                :color "secondary"
                                :onClick #(reset! !show-create-modal true)

                                }
                    "Eine neue News anlegen"
                    ]]
                  (for [[uuid text] (reverse (sort-by (fn [[uuid n]] (:lrFeedItem-date n))
                                                      (filter (fn [[uuid n]] (and (= (get-in n [:lrFeedItem-feed :lrFeed-uuid]) sel-tab) (:lrFeedItem-active n)))
                                                              @!data)))]
                    ^{:key (str "lrFeedItem-" uuid)}
                    [mui/grid
                     {:container false
                      :item true
                      :xl 7
                      :xs 12  ;extra-small: 0px
                      }
                     [text-block-card text !opened]
                     ]
                    )
                  ]

                 )





               ])
            ]]
          )

        ))))

